var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { useEffectWithoutCleanup, useState } from "GlobalShared/haunted/CustomHooks";
import { html } from "lit-html";
import { isEmpty } from "GlobalShared/helpers/stringHelper";
import { ONLY_PDF_ACCEPT_LIST } from "GlobalShared/helpers/fileHelper";
export const useIOSSModal = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [iossCertificateReference, setIOSSCertificateReference] = useState(void 0);
  const [iossNumber, setIOSSNumber] = useState(void 0);
  const [iossRegistrationDate, setIOSSRegistrationDate] = useState(void 0);
  const [iossCertificateValidationMessage, setIOSSCertificateValidationMessage] = useState(void 0);
  const [iossNumberValidationMessage, setIOSSNumberValidationMessage] = useState(void 0);
  const [iossRegistrationDateValidationMessage, setIOSSRegistrationDateValidationMessage] = useState(void 0);
  useEffectWithoutCleanup(() => __async(void 0, null, function* () {
    var _a, _b, _c;
    if (props && props.iossCertificate !== void 0) {
      setIOSSNumber((_a = props.iossCertificate) == null ? void 0 : _a.RegistrationNumber);
      setIOSSCertificateReference((_b = props.iossCertificate) == null ? void 0 : _b.CertificateReferenceId);
      setIOSSRegistrationDate((_c = props.iossCertificate) == null ? void 0 : _c.RegistrationDate);
    }
  }), [props]);
  const show = () => {
    setShowModal(true);
  };
  useEffectWithoutCleanup(() => {
    setIOSSCertificateReference(void 0);
    setIOSSNumber(void 0);
    setIOSSRegistrationDate(void 0);
    setIOSSCertificateValidationMessage(void 0);
    setIOSSNumberValidationMessage(void 0);
    setIOSSRegistrationDateValidationMessage(void 0);
  }, [showModal]);
  const template = html`${showModal ? html`<div>
				<dc-modal
					.visible=${showModal}
					@close=${() => setShowModal(false)}
					.header=${"Add IOSS certificate"}
					.content=${html`<div class="space-y-4 md:w-1/2">
						<dc-fileupload
							.label=${"IOSS certificate"}
							.fileName=${void 0}
							.fileReference=${iossCertificateReference}
							.validationMessage=${iossCertificateValidationMessage}
							.accept=${ONLY_PDF_ACCEPT_LIST}
							@upload=${(e) => __async(void 0, null, function* () {
    var _a;
    if (((_a = e.detail) == null ? void 0 : _a.files) && e.detail.files.length > 0) {
      setIOSSCertificateReference(yield props.uploadIOSSCertificate(e.detail.files[0]));
    }
  })}
						></dc-fileupload>
						<dc-input
							.label=${"IOSS number*"}
							.value=${iossNumber}
							.validationMessage=${iossNumberValidationMessage}
							@change=${(e) => {
    setIOSSNumber(e.detail.value);
  }}
						></dc-input>
						<dc-datepicker
							.label=${"IOSS registration date*"}
							.value=${iossRegistrationDate}
							.validationMessage=${iossRegistrationDateValidationMessage}
							@change=${(e) => {
    setIOSSRegistrationDate(e.detail.value);
  }}
						></dc-datepicker>
						<div>
							<button class="btn btn-primary mr-4" @click=${() => setShowModal(false)}>Cancel</button>
							<button
								class="btn btn-primary"
								@click=${() => __async(void 0, null, function* () {
    let isValid = true;
    setIOSSCertificateValidationMessage(void 0);
    setIOSSNumberValidationMessage(void 0);
    setIOSSRegistrationDateValidationMessage(void 0);
    if (isEmpty(iossNumber)) {
      setIOSSNumberValidationMessage("Required");
      isValid = false;
    }
    if (iossRegistrationDate === void 0) {
      setIOSSRegistrationDateValidationMessage("Required");
      isValid = false;
    }
    if (isValid) {
      const localCert = {
        CertificateReferenceId: iossCertificateReference,
        RegistrationNumber: iossNumber,
        RegistrationDate: iossRegistrationDate
      };
      yield props.save(localCert);
      setShowModal(false);
    }
  })}
							>
								Save
							</button>
						</div>
					</div>`}
				>
				</dc-modal>
		  </div>` : html``}`;
  return { show, template };
};
